import { SidebarMenuItem } from '../models/sidebar.model';
import { ICONS } from './icon.constants';
import { ROLES } from './role.constants';

export const MENU_CONFIG: SidebarMenuItem[] = [
    {
        label: 'Home',
        icon: ICONS.HOME,
        route: '/home'
    },
    {
        label: 'Users',
        icon: ICONS.USERS,
        route: '/users',
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        adminOnly: true
    },
    {
        label: 'Create New Inspection',
        icon: ICONS.SEND_INSPECTION,
        route: '/inspections/new',
        roles: [ROLES.ADMIN, ROLES.CS, ROLES.OPS]
    },
    {
        label: 'Inspection Report',
        icon: ICONS.INSPECTION_REPORT,
        route: '/inspection-report',
        roles: [ROLES.ADMIN, ROLES.CS, ROLES.OPS]
    },
    {
        label: 'Organizations',
        icon: ICONS.ORGANIZATION,
        route: '/organization',
        roles: [ROLES.SUPER_ADMIN]
    },
    {
        label: 'Bulk Import',
        icon: ICONS.IMPORT_MENU,
        route: '/bulk-import',
        roles: [ROLES.ADMIN],
        adminOnly: true
    },
    {
        label: 'Audit Logs',
        icon: ICONS.AUDIT_LOGS,
        route: '/audit-logs',
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.OPS]
    },
    {
        label: 'Carrier Master',
        icon: ICONS.CARRIER_MASTER,
        route: '/carrier-master',
        roles: [ROLES.ADMIN],
        adminOnly: true
    },
    {
        label: 'Settings',
        icon: ICONS.SETTINGS,
        route: '/settings',
        roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
        adminOnly: true
    },
    {
        label: 'Logout',
        icon: ICONS.LOGOUT
    }
];
